import Styles from './WorkflowBuilderItem.module.scss'

export const Divider = () => <div className={Styles.divider} />
